// extracted by mini-css-extract-plugin
export var agreed = "LockedDownload-module--agreed--8e6ef";
export var bottom = "LockedDownload-module--bottom--e0f14";
export var content = "LockedDownload-module--content--dc396";
export var contentGate = "LockedDownload-module--contentGate--de251";
export var fadePop = "LockedDownload-module--fade-pop--8cf16";
export var growHeightIn = "LockedDownload-module--grow-height-in--1da57";
export var icon = "LockedDownload-module--icon--e6e77";
export var terms = "LockedDownload-module--terms--f21ce";
export var wrapper = "LockedDownload-module--wrapper--cc73f";